import type { PackagingInformationEntry } from "~/domains/product/types/ProductData";
import type { ProductDescriptor } from "~/domains/product/types/ProductDescriptor";

export function isSelectablePack(descriptor: ProductDescriptor, entry: PackagingInformationEntry): boolean {
  const fifteenDigitEntry = descriptor.base.fifteenDigit?.[entry.packCode];
  if (!fifteenDigitEntry?.successor) {
    return true;
  }

  return fifteenDigitEntry.successor.slice(0, 13) !== descriptor.base.sapMaterialNumber;
}
